// Allow numbers with 1 decimal point while typing (don't truncate decimals live)
export const sanitizeNumberInput = (value: string, maxLimit = 999999999): string => {
    let sanitizedValue = value.replace(/[^0-9.]/g, "");
    const MAX_LIMIT = maxLimit;

    // Allow only one decimal point
    const decimalCount = (sanitizedValue.match(/\./g) || []).length;
    if (decimalCount > 1) {
        sanitizedValue = sanitizedValue.slice(0, sanitizedValue.lastIndexOf(".") + 1);
    }

    // Restrict max limit (but allow decimal typing)
    if (parseFloat(sanitizedValue) > MAX_LIMIT) {
        sanitizedValue = MAX_LIMIT.toString();
    }

    return sanitizedValue;
};


// Format number with commas (don't force rounding here)
export const formatNumberWithCommas = (val: string): string => {
    if (!val || val === ".") return val; // Show raw dot if user types only "."
    const num = Number(val.replace(/,/g, ""));
    if (isNaN(num)) return val;
    return num.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
};
